import React, { useState } from "react";
import { Table,Divider } from "antd";
import { SPLIT_TYPE_REVERSE } from "@/constants/util";

const Content = (props) => {

  const { dataSource,page,onTableChange=()=>{},onShowSizeChange=()=>{},onEdit=()=>{} }=props;

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const columns=[
    {
      title: '分账时间',
      dataIndex: 'createTime',
      key: 'createTime',
    },
    {
      title: '分账类型',
      dataIndex: 'type',
      key: 'type',
      render: (text) => SPLIT_TYPE_REVERSE[text],
    },
    {
      title: '点位名称',
      dataIndex: 'pointName',
      key: 'pointName',
    },
    {
      title: '投放商户',
      dataIndex: 'brandCompanyName',
      key: 'brandCompanyName',
    },
    {
      title: '投放周期',
      dataIndex: 'cycle',
      key: 'cycle',
    },
    {
      title: '收费总额/元',
      dataIndex: 'cost',
      key: 'cost',
    },
    {
      title: '评价扣款/元',
      dataIndex: 'evaluateDeduction',
      key: 'evaluateDeduction',
    },
    {
      title: '分账金额/元',
      dataIndex: 'shareAmount',
      key: 'shareAmount',
    }
  ]

  return (
    <div className="bg-white pt-16 pl-24 pr-24">
      <Table
        rowSelection={false}
        dataSource={dataSource}
        rowKey="companyId"
        columns={columns}
        pagination={{
          showTotal: () => `共${page.total}条`,
          total: page.total,
          current: page.pageNum,
          pageSize: page.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          pageSizeOptions: ["10", "20", "30", "40"],
          onChange: onTableChange,
          onShowSizeChange: onShowSizeChange,
        }}
      /> 
    </div>
  );
};

export default Content;
